import cn from 'classnames';
import type { ReactNode } from 'react';
import { SPosAbs } from '@shared/styles/styledComponentsCommon';
import * as st from './styles.module.scss';
import { ImageWithSkeleton } from '@shared/ui/img-with-skeleton/ui.tsx';

type PT = {
  size?: 'small' | 'large';
  photo?: string;
  children?: ReactNode;
  className?: string;
  imgClassName?: string;
};

const domen = window.location.origin;

export const CoachAvatar = ({ size = 'small', photo, children, className, imgClassName }: PT) => {
  const url =
    photo ||
    `${domen.includes('localhost') ? 'https://platform-api.nicecode.biz' : domen}/media/site_files/EmptyCoache.png`;

  return (
    <article className={cn(st.imgWrapper, st[size], className)}>
      <ImageWithSkeleton src={url} className={cn(st.img, imgClassName)} alt={`avatar coachCard ${photo}`} />
      {children && <SPosAbs className={st.children}>{children}</SPosAbs>}
    </article>
  );
};
